import createReducer from "./createReducer";
import { addFiltering } from "./common/Filtering";
import { addColumnFilters } from "./common/ColumnFilters";

import { SUBMISSION_LIST_ACTIONS } from "./actions/QA";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";

const initialSubmissionStore = {
	success: true,
	items: [],

	totalPages: 1,
	totalItems: 0,

	hasErrorLoading: false,
	isLoaded: false,
};

const actionCreators = {
	loadSubmissionList,
	clearList,
};

const handlers = {
	[SUBMISSION_LIST_ACTIONS.FETCH_SUBMISSION_LIST]: isLoadingList,
	[SUBMISSION_LIST_ACTIONS.FETCH_SUBMISSION_LIST_SUCCESS]: initSubmissionList,
	[SUBMISSION_LIST_ACTIONS.FETCH_SUBMISSION_LIST_ERROR]: errorSubmissionList,

	[SUBMISSION_LIST_ACTIONS.CLEAR_SUBMISSION_LIST]:resetList,
};


let reducerConfig = {
	typeRoot: "SUBMISSION_LIST_ACTIONS",
	initialState: initialSubmissionStore,
	actionTypes: SUBMISSION_LIST_ACTIONS,
	actionCreators,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, { sort: "dateCreated:DESC" });
// We need to enable this for logic downstream, but no columns are filterable
reducerConfig = addColumnFilters(reducerConfig, {

});

export function loadSubmissionList(libraryId){
	return (dispatch, getState) => {
		let state = getState();
		let { filterInfo } = state.qaSubmission;

		return dispatch({
			type: SUBMISSION_LIST_ACTIONS.FETCH_SUBMISSION_LIST,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url:`creative-libraries/${libraryId}/approval-history`,
				params: filterInfo,
				success: SUBMISSION_LIST_ACTIONS.FETCH_SUBMISSION_LIST_SUCCESS,
				error: SUBMISSION_LIST_ACTIONS.FETCH_SUBMISSION_LIST_ERROR,
			},
		});
	};
}

export function clearList(){
	return (dispatch) => {
		dispatch({ type: SUBMISSION_LIST_ACTIONS.CLEAR_SUBMISSION_LIST });
		return Promise.resolve({ success:true });
	};
}

function isLoadingList(state, action){
	return {
		...state,
		isLoaded: false,
	};
}

function initSubmissionList(state, action){
	let { data } = action.payload;

	return {
		...state,
		...data,
		items:data.items,
		isLoaded: true,
		hasErrorLoading: false,
	};
}

function errorSubmissionList(state, action){
	return {
		...state,
		totalPages: 1,
		totalItems: 0,
		isLoaded: true,
		hasErrorLoading: true,
	};
}

function resetList(state, action){
	return {
		...state,
		hasErrorLoading:false,
		isLoaded:false,
		items:[],
	};
}

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const Submission = reducerConfig.actionCreators;
export const PRIVATE = {
	...reducerConfig.handlers,
};
